/* eslint-disable react/prop-types */
import React from 'react';
import { HeadingText } from '@paypalcorp/pp-react';
import { isMobile } from 'react-device-detect';

export const ResponsiveHeadingText = ({ mobile = 'sm', desktop = 'lg', ...rest }) => (
  <HeadingText size={isMobile ? mobile : desktop} {...rest} />
);
